

import { Mixins, Component } from 'vue-property-decorator';
import PaymentRequirementsIncomingHandler from '../../mixins/Incoming/Handler/PaymentRequirementsIncomingHandler';

@Component
export default class PaymentRequirementsIncomingHandlerDialog extends Mixins(
	PaymentRequirementsIncomingHandler
) {}

